import axios from 'axios'

// 创建axios实例
const service = axios.create({
  // baseURL: 'https://yxf.api.jsonpro.cn',
  baseURL: 'https://peizhenapi.wmel.cn',
  // baseURL: 'http://47.111.65.108:8090',
  timeout: 60000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(config => {
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
    * code为非200是抛错 可结合自己业务进行修改
    */
    const res = response.data
    if (res.code !== 200) {
      // 请求失败
      if (res.code === 401) {
        // 401:未登录;
      }
      return Promise.reject('error')
    } else {
      return response.data
    }
  }, error => {
    // 请求错误
    console.log('err' + error)
    return Promise.reject(error)
  }
)

export default service
